// Pre-seeded mock loads for the broker dashboard preview.
export const STATUS_OPTIONS = ["Assigned", "Dispatched", "In Transit", "Delivered"];

export const statusKey = (status) => {
  switch (status) {
    case "Assigned":    return "assigned";
    case "Dispatched":  return "dispatched";
    case "In Transit":  return "in_transit";
    case "Delivered":   return "delivered";
    default:            return "assigned";
  }
};

export const MOCK_LOADS = [
  {
    id: "L-10421",
    loadNumber: "RD-10421",
    customer: "Walmart DC #6094",
    carrierName: "Bluebird Trucking LLC",
    carrierMC: "MC-887421",
    driverName: "Marcus Reyes",
    driverPhone: "(404) 555-2381",
    origin: "Atlanta, GA",
    destination: "Dallas, TX",
    customerRate: 3800,
    carrierPay: 3100,
    fsc: 215,
    status: "In Transit",
    shipperAddress: "1240 Industrial Blvd, Atlanta, GA 30318",
    consigneeAddress: "8800 Stemmons Fwy, Dallas, TX 75247",
    pickupDate: "2026-02-10",
    pickupTime: "08:00",
    deliveryDate: "2026-02-12",
    deliveryTime: "14:00",
    notes: "Driver must check in with guard shack. Pickup #889201. No early arrivals.",
  },
  {
    id: "L-10422",
    loadNumber: "RD-10422",
    customer: "Home Depot Reload",
    carrierName: "Pioneer Freight Co.",
    carrierMC: "MC-553902",
    driverName: "Daniel Cho",
    driverPhone: "(312) 555-9012",
    origin: "Chicago, IL",
    destination: "Indianapolis, IN",
    customerRate: 1450,
    carrierPay: 1100,
    fsc: 95,
    status: "Dispatched",
    shipperAddress: "4500 Cargo Way, Chicago, IL 60638",
    consigneeAddress: "2455 Distribution Pkwy, Indianapolis, IN 46241",
    pickupDate: "2026-02-11",
    pickupTime: "09:30",
    deliveryDate: "2026-02-11",
    deliveryTime: "18:00",
    notes: "Reload code: HD-2240. Bring 2 straps minimum. Scale ticket required.",
  },
  {
    id: "L-10423",
    loadNumber: "RD-10423",
    customer: "Amazon AHL Logistics",
    carrierName: "Rapid Hauler Express",
    carrierMC: "MC-712339",
    driverName: "Tanya Brooks",
    driverPhone: "(602) 555-7744",
    origin: "Phoenix, AZ",
    destination: "Los Angeles, CA",
    customerRate: 2200,
    carrierPay: 1750,
    fsc: 140,
    status: "Assigned",
    shipperAddress: "9900 W Buckeye Rd, Phoenix, AZ 85043",
    consigneeAddress: "12500 E Slauson Ave, Santa Fe Springs, CA 90670",
    pickupDate: "2026-02-12",
    pickupTime: "07:00",
    deliveryDate: "2026-02-13",
    deliveryTime: "10:00",
    notes: "Tell gate guard 'Pickup for AMZL-44'. Hard hat + vest required.",
  },
  {
    id: "L-10424",
    loadNumber: "RD-10424",
    customer: "Costco Wholesale #112",
    carrierName: "Granite Mountain Transport",
    carrierMC: "MC-449012",
    driverName: "Hector Mendez",
    driverPhone: "(801) 555-3322",
    origin: "Salt Lake City, UT",
    destination: "Denver, CO",
    customerRate: 1900,
    carrierPay: 1500,
    fsc: 110,
    status: "Delivered",
    shipperAddress: "2300 S 7200 W, Salt Lake City, UT 84128",
    consigneeAddress: "4949 Quebec St, Commerce City, CO 80022",
    pickupDate: "2026-02-08",
    pickupTime: "06:00",
    deliveryDate: "2026-02-09",
    deliveryTime: "08:30",
    notes: "Delivered POD signed by D. Reynolds at 08:24.",
  },
  {
    id: "L-10425",
    loadNumber: "RD-10425",
    customer: "Target T-3340",
    carrierName: "Liberty Lanes Inc.",
    carrierMC: "MC-928110",
    driverName: "Priya Anand",
    driverPhone: "(214) 555-4400",
    origin: "Dallas, TX",
    destination: "Houston, TX",
    customerRate: 1250,
    carrierPay: 950,
    fsc: 70,
    status: "In Transit",
    shipperAddress: "1100 Empire Central Dr, Dallas, TX 75247",
    consigneeAddress: "12300 N Houston Rosslyn Rd, Houston, TX 77086",
    pickupDate: "2026-02-10",
    pickupTime: "10:00",
    deliveryDate: "2026-02-10",
    deliveryTime: "20:00",
    notes: "Sealed trailer. Driver may NOT break seal. Seal #44521.",
  },
  {
    id: "L-10426",
    loadNumber: "RD-10426",
    customer: "Lowes #2231 Reload",
    carrierName: "Apex Cargo Lines",
    carrierMC: "MC-660081",
    driverName: "Brian Walsh",
    driverPhone: "(704) 555-6611",
    origin: "Charlotte, NC",
    destination: "Nashville, TN",
    customerRate: 1700,
    carrierPay: 1350,
    fsc: 105,
    status: "Assigned",
    shipperAddress: "8800 Wilkinson Blvd, Charlotte, NC 28214",
    consigneeAddress: "6700 Centennial Blvd, Nashville, TN 37209",
    pickupDate: "2026-02-13",
    pickupTime: "08:30",
    deliveryDate: "2026-02-13",
    deliveryTime: "17:00",
    notes: "Confirm pickup # at gate: LOW-887723. Lumper at delivery (paid by broker).",
  },
];
